<script setup lang="ts">
    import ConfirmDialog from 'primevue/confirmdialog';
    import { MARKET_SWITCH_CONFIRMATION_DIALOG } from '@/constants';
</script>

<template>
    <ConfirmDialog
        id="market-switch-confirm-dialog"
        :group="MARKET_SWITCH_CONFIRMATION_DIALOG"
        class="market-switch-confirm-dialog"
        :draggable="false"
    />
</template>
